import React from 'react'
import ReactDOM from 'react-dom/client'
import App from 'App'
import reportWebVitals from 'reportWebVitals'
import DocUploadPage from 'pages/DocUploadPage'
import PdsPage from 'pages/PdsPage'

// Load Dynatrace dynamically from environment variable with security validation
const loadDynatrace = () => {
    const dynatraceUrl = process.env.REACT_APP_DYNATRACE_URL

    if (!dynatraceUrl) {
        return // No URL configured, skip loading
    }

    // Validate that the URL is from an approved Dynatrace domain
    // This prevents potential XSS if the env var is somehow compromised
    const allowedDomains = ['dynatrace.ford.com', 'uemm.dynatrace.ford.com', 'uemmqa.dynatrace.ford.com']

    try {
        const url = new URL(dynatraceUrl)

        // Check if the hostname ends with one of the allowed domains
        const isAllowedDomain = allowedDomains.some(
            (domain) => url.hostname === domain || url.hostname.endsWith('.' + domain)
        )

        if (!isAllowedDomain) {
            console.warn('Dynatrace URL domain not allowed:', url.hostname)
            return
        }

        // Ensure HTTPS protocol
        if (url.protocol !== 'https:') {
            console.warn('Dynatrace URL must use HTTPS')
            return
        }

        // Now safe to create the script element
        const script = document.createElement('script')
        script.defer = true
        script.type = 'text/javascript'
        script.src = dynatraceUrl
        script.crossOrigin = 'anonymous'
        script.onerror = () => {
            console.warn('Failed to load Dynatrace monitoring script')
        }
        document.head.appendChild(script)
    } catch (error) {
        console.warn('Invalid Dynatrace URL:', error.message)
    }
}

// Load Dynatrace before rendering app
loadDynatrace()

const authToken = process.env.REACT_APP_AUTH_TOKEN // Auth token is required for all API calls

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        <App
            authToken={authToken}
            brand={process.env.REACT_APP_BRAND}
            country={process.env.REACT_APP_COUNTRY}
            dealJacketId={process.env.REACT_APP_DEAL_JACKET_ID}
            dealerId={process.env.REACT_APP_DEALER_ID}
            lang={process.env.REACT_APP_LANG}
            maintenance={process.env.REACT_APP_MAINTENANCE_STATE}
            vehicleImage={process.env.REACT_APP_VEHICLE_IMAGE}
            pdsStatus={process.env.REACT_APP_PDS_STATUS}
            dealerName={process.env.REACT_APP_DEALER_NAME}
            dealerPhoneNumber={process.env.REACT_APP_DEALER_PHONE_NUMBER}
            orderId={process.env.REACT_APP_ORDER_ID}
        >
            <DocUploadPage />
            <PdsPage />
        </App>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
